// @ts-nocheck
// TODO: tighten types after migration
import React, { useState, useEffect, useRef } from 'react';
import './ContentPlanner.css';
import { API_ENDPOINTS } from '../config/api';

const MONTH_NAMES = [
    'January', 'February', 'March', 'April', 'May', 'June',
    'July', 'August', 'September', 'October', 'November', 'December'
];
const DAY_HEADERS = ['S', 'M', 'T', 'W', 'T', 'F', 'S'];

function FlameIcon({ size }) {
    var s = size || 44;
    return (
        <svg className="cp-flame" viewBox="0 0 40 52" width={s} height={s} xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
            <path d="M20 2C16 10 8 16 6 24C4 32 8 40 14 44C12 40 13 36 16 33C17 37 19 40 20 42C21 40 23 37 24 33C27 36 28 40 26 44C32 40 36 32 34 24C32 16 24 10 20 2Z" fill="#f97316"/>
            <path d="M20 22C18 26 14 30 14 35C14 39.4 16.7 43 20 43C23.3 43 26 39.4 26 35C26 30 22 26 20 22Z" fill="#fbbf24"/>
        </svg>
    );
}

function formatScheduleDate(dateStr) {
    if (!dateStr) return '—';
    var d = new Date(dateStr);
    var date = d.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
    var time = d.toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit' });
    return date + ' · ' + time;
}

function useCountdown(deadlineStr) {
    var [remaining, setRemaining] = useState(function() {
        return deadlineStr ? Math.floor((new Date(deadlineStr) - Date.now()) / 1000) : null;
    });
    useEffect(function() {
        if (!deadlineStr) return;
        var update = function() {
            setRemaining(Math.floor((new Date(deadlineStr) - Date.now()) / 1000));
        };
        var id = setInterval(update, 1000);
        return function() { clearInterval(id); };
    }, [deadlineStr]);
    return remaining;
}

function Countdown({ deadline }) {
    var secs = useCountdown(deadline);
    if (secs === null) return null;
    if (secs < 0) return <span className="cp-countdown cp-countdown-overdue">overdue</span>;
    var d = Math.floor(secs / 86400);
    var h = Math.floor((secs % 86400) / 3600);
    var m = Math.floor((secs % 3600) / 60);
    var s = secs % 60;
    var parts = [];
    if (d > 0) parts.push(d + 'd');
    if (d > 0 || h > 0) parts.push(h + 'h');
    if (d > 0 || h > 0 || m > 0) parts.push(m + 'm');
    parts.push(s + 's');
    return <span className="cp-countdown">{parts.join(' ')}</span>;
}

// Convert ISO string to datetime-local input value (local time)
function toDatetimeLocal(isoStr) {
    if (!isoStr) return '';
    var d = new Date(isoStr);
    var local = new Date(d.getTime() - d.getTimezoneOffset() * 60000);
    return local.toISOString().slice(0, 16);
}

export default function ContentPlanner() {
    var today = new Date();
    var [year, setYear] = useState(today.getFullYear());
    var [month, setMonth] = useState(today.getMonth() + 1);
    var [data, setData] = useState(null);
    var [loading, setLoading] = useState(false);
    var [error, setError] = useState('');
    var [publishingId, setPublishingId] = useState(null);
    var [filter, setFilter] = useState(null);
    var [showMonthPicker, setShowMonthPicker] = useState(false);
    var [showYearPicker, setShowYearPicker] = useState(false);
    var [activeView, setActiveView] = useState('streak');
    var [annualYear, setAnnualYear] = useState(today.getFullYear());
    var [fetchKey, setFetchKey] = useState(0);

    // Edit modal state
    var [editModal, setEditModal] = useState({ open: false, type: null, item: null, dateValue: '' });
    var [saving, setSaving] = useState(false);
    var [saveError, setSaveError] = useState('');

    var [activeTooltip, setActiveTooltip] = useState(null);
    var tooltipTimerRef = useRef(null);

    function showTooltip(name) {
        if (tooltipTimerRef.current) clearTimeout(tooltipTimerRef.current);
        setActiveTooltip(name);
        tooltipTimerRef.current = setTimeout(function() { setActiveTooltip(null); }, 4000);
    }

    var chipsRef = useRef(null);
    var monthPickerRef = useRef(null);
    var yearPickerRef = useRef(null);
    var modalOverlayRef = useRef(null);

    var yearOptions = [];
    for (var yi = today.getFullYear() - 5; yi <= today.getFullYear() + 2; yi++) yearOptions.push(yi);

    // Close month/year pickers on outside click
    useEffect(function() {
        if (!showMonthPicker && !showYearPicker) return;
        function handlePickerClick(e) {
            if (showMonthPicker && monthPickerRef.current && !monthPickerRef.current.contains(e.target)) {
                setShowMonthPicker(false);
            }
            if (showYearPicker && yearPickerRef.current && !yearPickerRef.current.contains(e.target)) {
                setShowYearPicker(false);
            }
        }
        document.addEventListener('mousedown', handlePickerClick);
        return function() { document.removeEventListener('mousedown', handlePickerClick); };
    }, [showMonthPicker, showYearPicker]);

    // Auto-clear filter after 15 seconds
    useEffect(function() {
        if (!filter) return;
        var timer = setTimeout(function() { setFilter(null); }, 15000);
        return function() { clearTimeout(timer); };
    }, [filter]);

    // Clear filter on click outside chips
    useEffect(function() {
        if (!filter) return;
        function handleOutsideClick(e) {
            if (chipsRef.current && !chipsRef.current.contains(e.target)) {
                setFilter(null);
            }
        }
        document.addEventListener('click', handleOutsideClick);
        return function() { document.removeEventListener('click', handleOutsideClick); };
    }, [filter]);

    // Close modal on overlay click
    useEffect(function() {
        if (!editModal.open) return;
        function handleOverlayClick(e) {
            if (modalOverlayRef.current && e.target === modalOverlayRef.current) {
                closeModal();
            }
        }
        document.addEventListener('mousedown', handleOverlayClick);
        return function() { document.removeEventListener('mousedown', handleOverlayClick); };
    }, [editModal.open]);

    // Fetch all data — re-fetches when fetchKey changes
    useEffect(function() {
        setLoading(true);
        setError('');
        var token = sessionStorage.getItem('token');
        fetch(API_ENDPOINTS.ADMIN.CONTENT_PLANNER, {
            headers: { Authorization: 'Bearer ' + token }
        })
        .then(function(res) { return res.text().then(function(text) { return { ok: res.ok, text: text }; }); })
        .then(function(result) {
            var trimmed = result.text ? result.text.trim() : '';
            if (!trimmed || trimmed === 'undefined' || trimmed === 'null') {
                setError('Empty response from server');
                return;
            }
            var parsed;
            try { parsed = JSON.parse(trimmed); } catch (e) { setError('Invalid response from server'); return; }
            if (!result.ok) { setError(parsed.error || 'Failed to fetch data'); return; }
            setData(parsed);
        })
        .catch(function() { setError('Network error. Please try again.'); })
        .finally(function() { setLoading(false); });
    }, [fetchKey]);

    function refreshData() {
        setFetchKey(function(k) { return k + 1; });
    }

    function handlePublishNow(type, item) {
        var id = item._id;
        var collection = type === 'blog' ? 'BlogContent' : 'PodcastsAudioDetails';
        var token = sessionStorage.getItem('token');
        setPublishingId(id);
        fetch(API_ENDPOINTS.ADMIN.PUBLISH_NOW(collection, id), {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Authorization: 'Bearer ' + token }
        })
        .then(function(res) { return res.text().then(function(text) { return { ok: res.ok, text: text }; }); })
        .then(function(result) {
            if (!result.ok) { alert('Failed to publish. Please try again.'); return; }
            refreshData();
        })
        .catch(function() { alert('Network error. Please try again.'); })
        .finally(function() { setPublishingId(null); });
    }

    function prevMonth() {
        if (month === 1) { setMonth(12); setYear(function(y) { return y - 1; }); }
        else setMonth(function(m) { return m - 1; });
    }

    function nextMonth() {
        if (month === 12) { setMonth(1); setYear(function(y) { return y + 1; }); }
        else setMonth(function(m) { return m + 1; });
    }

    function toggleFilter(type) {
        setFilter(function(prev) { return prev === type ? null : type; });
    }

    // Open edit modal for a scheduled item
    function openEditModal(type, item) {
        var dateStr = type === 'blog' ? item.createdAt : item.date;
        setEditModal({ open: true, type: type, item: item, dateValue: toDatetimeLocal(dateStr) });
        setSaveError('');
    }

    function closeModal() {
        setEditModal({ open: false, type: null, item: null, dateValue: '' });
        setSaveError('');
    }

    function handleSaveSchedule() {
        if (!editModal.item || !editModal.dateValue) return;
        setSaving(true);
        setSaveError('');
        var token = sessionStorage.getItem('token');
        var id = editModal.item._id;
        var collection = editModal.type === 'blog' ? 'BlogContent' : 'PodcastsAudioDetails';
        var dateField = editModal.type === 'blog' ? 'createdAt' : 'date';
        var newDate = new Date(editModal.dateValue).toISOString();
        var updatePayload = {};
        updatePayload[dateField] = newDate;

        fetch(API_ENDPOINTS.ADMIN.COLLECTION_UPDATE(collection, id), {
            method: 'PATCH',
            headers: {
                'Content-Type': 'application/json',
                Authorization: 'Bearer ' + token
            },
            body: JSON.stringify(updatePayload)
        })
        .then(function(res) { return res.text().then(function(text) { return { ok: res.ok, text: text }; }); })
        .then(function(result) {
            var trimmed = result.text ? result.text.trim() : '';
            if (!result.ok) {
                var msg = 'Failed to update';
                try { var parsed = JSON.parse(trimmed); msg = parsed.error || parsed.message || msg; } catch(e) {}
                setSaveError(msg);
                return;
            }
            closeModal();
            refreshData();
        })
        .catch(function() { setSaveError('Network error. Please try again.'); })
        .finally(function() { setSaving(false); });
    }

    // Client-side grouping
    var allBlogs = (data && data.allPublished && data.allPublished.blogs) || [];
    var allPodcasts = (data && data.allPublished && data.allPublished.podcasts) || [];

    var blogsByDay = {};
    var podcastsByDay = {};
    var blogMonthCount = 0;
    var podcastMonthCount = 0;

    allBlogs.forEach(function(b) {
        if (!b.createdAt) return;
        var d = new Date(b.createdAt);
        if (d.getFullYear() === year && d.getMonth() + 1 === month) {
            var day = d.getDate();
            blogsByDay[day] = (blogsByDay[day] || 0) + 1;
            blogMonthCount++;
        }
    });

    allPodcasts.forEach(function(p) {
        if (!p.date) return;
        var d = new Date(p.date);
        if (d.getFullYear() === year && d.getMonth() + 1 === month) {
            var day = d.getDate();
            podcastsByDay[day] = (podcastsByDay[day] || 0) + 1;
            podcastMonthCount++;
        }
    });

    // Annual report
    var annualBlogsByMonth = {};
    var annualPodcastsByMonth = {};

    allBlogs.forEach(function(b) {
        if (!b.createdAt) return;
        var d = new Date(b.createdAt);
        if (d.getFullYear() === annualYear) {
            var m = d.getMonth();
            annualBlogsByMonth[m] = (annualBlogsByMonth[m] || 0) + 1;
        }
    });

    allPodcasts.forEach(function(p) {
        if (!p.date) return;
        var d = new Date(p.date);
        if (d.getFullYear() === annualYear) {
            var m = d.getMonth();
            annualPodcastsByMonth[m] = (annualPodcastsByMonth[m] || 0) + 1;
        }
    });

    var scheduledBlogs = (data && data.schedule && data.schedule.blogs) || [];
    var scheduledPodcasts = (data && data.schedule && data.schedule.podcasts) || [];

    var daysInMonth = new Date(year, month, 0).getDate();
    var firstDayOfWeek = new Date(year, month - 1, 1).getDay();
    var isCurrentMonth = year === today.getFullYear() && month === today.getMonth() + 1;
    var todayDate = today.getDate();

    var calendarCells = [];
    for (var i = 0; i < firstDayOfWeek; i++) calendarCells.push(null);
    for (var d = 1; d <= daysInMonth; d++) calendarCells.push(d);

    return (
        <div className="content-planner mt-[14px] rounded-[14px] border border-slider bg-bg p-[12px] shadow-[0_2px_10px_rgba(0,0,0,0.06)]">
            {/* Left: Streak / Calendar Planner */}
            <div className="cp-streak-planner flex flex-col gap-[12px] xl:flex-row">

                {/* Left nav panel — icon-only buttons with CSS tooltips */}
                <div className="cp-sp-left-panel flex gap-[8px] xl:flex-col">
                    <button
                        className={'cp-sp-nav-btn' + (activeView === 'streak' ? ' cp-sp-nav-active' : '') + (activeTooltip === 'streak' ? ' cp-tooltip-active' : '')}
                        onClick={function() { setActiveView('streak'); showTooltip('streak'); }}
                        data-tooltip="Streak Monitor"
                    >
                        <i className="fi fi-sr-flame"></i>
                    </button>
                    <button
                        className={'cp-sp-nav-btn' + (activeView === 'annual' ? ' cp-sp-nav-active' : '') + (activeTooltip === 'annual' ? ' cp-tooltip-active' : '')}
                        onClick={function() { setActiveView('annual'); showTooltip('annual'); }}
                        data-tooltip="Annual Report"
                    >
                        <i className="fi fi-rr-schedule"></i>
                    </button>
                </div>

                {/* Right content area */}
                <div className="cp-sp-right flex-1">

                    {/* ── STREAK VIEW ── */}
                    {activeView === 'streak' && (
                        <>
                            <div className="cp-counts-row" ref={chipsRef}>
                                <div
                                    className={'cp-count-chip' + (filter === 'blog' ? ' cp-chip-active cp-chip-active-blog' : '')}
                                    onClick={function() { toggleFilter('blog'); }}
                                    title={filter === 'blog' ? 'Clear filter' : 'Filter calendar by Blog'}
                                >
                                    <span className="cp-chip-flame"><FlameIcon size={32} /></span>
                                    <div className="cp-streak-display">
                                        <span className="cp-streak-num cp-blog-color">
                                            {loading ? '…' : blogMonthCount}
                                        </span>
                                    </div>
                                    <span className="cp-streak-label cp-blog-label">Blog</span>
                                </div>
                                <div
                                    className={'cp-count-chip' + (filter === 'podcast' ? ' cp-chip-active cp-chip-active-podcast' : '')}
                                    onClick={function() { toggleFilter('podcast'); }}
                                    title={filter === 'podcast' ? 'Clear filter' : 'Filter calendar by Podcast'}
                                >
                                    <span className="cp-chip-flame"><FlameIcon size={32} /></span>
                                    <div className="cp-streak-display">
                                        <span className="cp-streak-num cp-podcast-color">
                                            {loading ? '…' : podcastMonthCount}
                                        </span>
                                    </div>
                                    <span className="cp-streak-label cp-podcast-label">Podcast</span>
                                </div>
                            </div>

                            <div className="cp-calendar-card">
                                <div className="cp-cal-nav">
                                    <button className="cp-cal-btn" onClick={prevMonth} aria-label="Previous month">
                                        <i className="fi fi-br-angle-small-left"></i>
                                    </button>
                                    <span className="cp-cal-title">
                                        <span className="cp-title-wrap" ref={monthPickerRef}>
                                            <button className="cp-title-btn" onClick={function() { setShowMonthPicker(function(v) { return !v; }); setShowYearPicker(false); }}>
                                                {MONTH_NAMES[month - 1].toUpperCase()}
                                            </button>
                                            {showMonthPicker && (
                                                <div className="cp-picker-dropdown">
                                                    {MONTH_NAMES.map(function(name, i) {
                                                        return (
                                                            <div key={i} className={'cp-picker-item' + (month === i + 1 ? ' cp-picker-active' : '')} onClick={function(m) { return function() { setMonth(m); setShowMonthPicker(false); }; }(i + 1)}>
                                                                {name}
                                                            </div>
                                                        );
                                                    })}
                                                </div>
                                            )}
                                        </span>
                                        <span className="cp-title-wrap" ref={yearPickerRef}>
                                            <button className="cp-title-btn" onClick={function() { setShowYearPicker(function(v) { return !v; }); setShowMonthPicker(false); }}>
                                                {year}
                                            </button>
                                            {showYearPicker && (
                                                <div className="cp-picker-dropdown">
                                                    {yearOptions.map(function(y) {
                                                        return (
                                                            <div key={y} className={'cp-picker-item' + (year === y ? ' cp-picker-active' : '')} onClick={function(yr) { return function() { setYear(yr); setShowYearPicker(false); }; }(y)}>
                                                                {y}
                                                            </div>
                                                        );
                                                    })}
                                                </div>
                                            )}
                                        </span>
                                    </span>
                                    <button className="cp-cal-btn" onClick={nextMonth} aria-label="Next month">
                                        <i className="fi fi-br-angle-small-right"></i>
                                    </button>
                                </div>

                                {loading && <div className="cp-cal-msg">Loading…</div>}
                                {!loading && error && <div className="cp-cal-msg cp-cal-error">{error}</div>}

                                {!loading && !error && (
                                    <div className="cp-cal-grid">
                                        {DAY_HEADERS.map(function(h, i) {
                                            return <div key={i} className="cp-cal-head">{h}</div>;
                                        })}
                                        {calendarCells.map(function(day, idx) {
                                            if (!day) return <div key={'e' + idx} className="cp-cal-cell cp-cal-empty" />;
                                            var isToday = isCurrentMonth && day === todayDate;
                                            var bCount = blogsByDay[day] || 0;
                                            var pCount = podcastsByDay[day] || 0;

                                            var isDimmed = false;
                                            if (filter === 'blog') isDimmed = bCount === 0;
                                            else if (filter === 'podcast') isDimmed = pCount === 0;

                                            return (
                                                <div key={day} className={'cp-cal-cell' + (isToday ? ' cp-cal-today' : '')}>
                                                    <span className={'cp-day-num' + (isDimmed ? ' cp-day-dimmed' : '')}>{day}</span>
                                                    {bCount > 0 && (
                                                        <span className={'cp-b-row' + (isDimmed ? ' cp-row-dimmed' : '')}>
                                                            {'B'.repeat(Math.min(bCount, 4)) + (bCount > 4 ? '+' : '')}
                                                        </span>
                                                    )}
                                                    {pCount > 0 && (
                                                        <span className={'cp-p-row' + (isDimmed ? ' cp-row-dimmed' : '')}>
                                                            {'P'.repeat(Math.min(pCount, 4)) + (pCount > 4 ? '+' : '')}
                                                        </span>
                                                    )}
                                                </div>
                                            );
                                        })}
                                    </div>
                                )}
                            </div>
                        </>
                    )}

                    {/* ── ANNUAL REPORT VIEW ── */}
                    {activeView === 'annual' && (
                        <div className="cp-annual">
                            <div className="cp-annual-nav">
                                <button className="cp-cal-btn" onClick={function() { setAnnualYear(function(y) { return y - 1; }); }} aria-label="Previous year">
                                    <i className="fi fi-br-angle-small-left"></i>
                                </button>
                                <span className="cp-annual-year">{annualYear}</span>
                                <button className="cp-cal-btn" onClick={function() { setAnnualYear(function(y) { return y + 1; }); }} aria-label="Next year">
                                    <i className="fi fi-br-angle-small-right"></i>
                                </button>
                            </div>

                            {loading && <div className="cp-cal-msg">Loading…</div>}
                            {!loading && error && <div className="cp-cal-msg cp-cal-error">{error}</div>}

                            {!loading && !error && (
                                <div className="cp-annual-grid">
                                    {MONTH_NAMES.map(function(name, i) {
                                        var bCount = annualBlogsByMonth[i] || 0;
                                        var pCount = annualPodcastsByMonth[i] || 0;
                                        return (
                                            <div key={i} className="cp-annual-month-card">
                                                <span className="cp-annual-month-name">{name}</span>
                                                <span className="cp-annual-stat">
                                                    <span className="cp-annual-stat-label cp-blog-color">Blog</span>
                                                    <strong className="cp-annual-stat-val cp-blog-color">{bCount}</strong>
                                                </span>
                                                <span className="cp-annual-stat">
                                                    <span className="cp-annual-stat-label cp-podcast-color">Podcast</span>
                                                    <strong className="cp-annual-stat-val cp-podcast-color">{pCount}</strong>
                                                </span>
                                            </div>
                                        );
                                    })}
                                </div>
                            )}
                        </div>
                    )}
                </div>
            </div>

            {/* Vertical divider */}
            <div className="cp-divider hidden w-[1px] bg-slider xl:block" aria-hidden="true"></div>

            {/* Right: Upcoming Scheduled Content */}
            <div className="cp-schedule rounded-[12px] border border-slider p-[10px] xl:w-[38%]">
                <div className="cp-schedule-header-row">
                    <span className="cp-schedule-section-title">Scheduled Content</span>
                    <button className="cp-refresh-btn" onClick={refreshData} title="Refresh scheduled list" disabled={loading}>
                        <i className={'fi fi-br-refresh' + (loading ? ' cp-spin' : '')}></i>
                    </button>
                </div>

                <div className="cp-schedule-card">
                    <h3 className="cp-schedule-heading cp-blog-color">Blog</h3>
                    {loading && <p className="cp-schedule-empty">Loading…</p>}
                    {!loading && scheduledBlogs.length === 0 && (
                        <p className="cp-schedule-empty">No upcoming scheduled blogs</p>
                    )}
                    {!loading && scheduledBlogs.length > 0 && (
                        <ul className="cp-list">
                            {scheduledBlogs.map(function(b, i) {
                                var isOverdue = b.createdAt && new Date(b.createdAt) <= new Date();
                                return (
                                    <li key={i} className="cp-list-item cp-list-item-clickable" onClick={function() { openEditModal('blog', b); }}>
                                        <span className="cp-item-num cp-blog-color">{b.postNumber}</span>
                                        <div className="cp-item-meta">
                                            <div className="cp-item-date-row">
                                                <span className="cp-item-date">{formatScheduleDate(b.createdAt)}</span>
                                                <Countdown deadline={b.createdAt} />
                                                {isOverdue && (
                                                    <button
                                                        className="cp-publish-now-btn"
                                                        disabled={publishingId === b._id}
                                                        onClick={function(e) { e.stopPropagation(); handlePublishNow('blog', b); }}
                                                    >
                                                        {publishingId === b._id ? '...' : 'Publish'}
                                                    </button>
                                                )}
                                            </div>
                                            <span className="cp-item-title">{b.title}</span>
                                        </div>
                                        <i className="fi fi-rr-blog-pencil cp-item-edit-icon cp-blog-color"></i>
                                    </li>
                                );
                            })}
                        </ul>
                    )}
                </div>

                <div className="cp-schedule-card">
                    <h3 className="cp-schedule-heading cp-podcast-color">Podcast</h3>
                    {loading && <p className="cp-schedule-empty">Loading…</p>}
                    {!loading && scheduledPodcasts.length === 0 && (
                        <p className="cp-schedule-empty">No upcoming scheduled podcasts</p>
                    )}
                    {!loading && scheduledPodcasts.length > 0 && (
                        <ul className="cp-list">
                            {scheduledPodcasts.map(function(p, i) {
                                return (
                                    <li key={i} className="cp-list-item cp-list-item-clickable" onClick={function() { openEditModal('podcast', p); }}>
                                        <span className="cp-item-num cp-podcast-color">{p.podcastNumber}</span>
                                        <div className="cp-item-meta">
                                            <div className="cp-item-date-row">
                                                <span className="cp-item-date">{formatScheduleDate(p.date)}</span>
                                                <Countdown deadline={p.date} />
                                            </div>
                                            <span className="cp-item-title">{p.title}</span>
                                        </div>
                                        <i className="fi fi-rr-blog-pencil cp-item-edit-icon cp-podcast-color"></i>
                                    </li>
                                );
                            })}
                        </ul>
                    )}
                </div>
            </div>

            {/* ── Edit Schedule Modal ── */}
            {editModal.open && (
                <div className="cp-modal-overlay" ref={modalOverlayRef}>
                    <div className="cp-modal">
                        <div className="cp-modal-header">
                            <span className={'cp-modal-type-badge ' + (editModal.type === 'blog' ? 'cp-blog-color' : 'cp-podcast-color')}>
                                {editModal.type === 'blog' ? 'Blog' : 'Podcast'}
                            </span>
                            <button className="cp-modal-close" onClick={closeModal} aria-label="Close">
                                <i className="fi fi-br-cross-small"></i>
                            </button>
                        </div>
                        <p className="cp-modal-title">{editModal.item && editModal.item.title}</p>
                        <label className="cp-modal-label">Reschedule Date &amp; Time</label>
                        <input
                            type="datetime-local"
                            className="cp-modal-input"
                            value={editModal.dateValue}
                            onChange={function(e) { setEditModal(function(prev) { return { ...prev, dateValue: e.target.value }; }); }}
                        />
                        {saveError && <p className="cp-modal-error">{saveError}</p>}
                        <div className="cp-modal-actions">
                            <button className="cp-modal-btn cp-modal-cancel" onClick={closeModal} disabled={saving}>
                                Cancel
                            </button>
                            <button
                                className={'cp-modal-btn cp-modal-save ' + (editModal.type === 'blog' ? 'cp-modal-save-blog' : 'cp-modal-save-podcast')}
                                onClick={handleSaveSchedule}
                                disabled={saving || !editModal.dateValue}
                            >
                                {saving ? 'Saving…' : 'Save'}
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}
